/*
 * Title: Leaderboard/MobileHead.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Leaderboard page title and close head only show on mobile
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import { NavLink } from "react-router-dom";
import close from "@assets/close.png";
import { useSelector } from "react-redux";

type Props = {};

const MobileHeader: React.FC<Props> = (props) => {
  const creator = useSelector((state: any) => state.creator);
  const cname = creator.creator?.username;
  const pname = creator?.program.name;
  
  const pageYOffset = useSelector((state: any) => (state.util?.pageYOffset || 0));

  return (
    <div className={`px-5 pt-5 z-50 lg:hidden ${pageYOffset > 50 ? 'bg-tile pb-6 sticky rounded-b-[40px] -top-[1px] w-full slide-in' : ''}`}>
      {/* mobile header title & go back start  */}
      <div className="flex items-center justify-between">
        <h4 className="font-medium tile-inlay-primary text-[24px] tracking-wider">
          Leaderboard
        </h4>
        <NavLink
          to={`/${cname}/${pname}/earn`}
          className="text-xl font-semibold tracking-wider text-center tile-inlay-primary cursor-pointer gap-x-2">
          {/* <img src={close} alt="CloseHead" className="object-contain w-4 h-4" /> */}
          <svg className="h-7 w-7 tile-inlay-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round">  <line x1="18" y1="6" x2="6" y2="18" />  <line x1="6" y1="6" x2="18" y2="18" /></svg>
        </NavLink>
      </div>
    </div>
  );
};

export default MobileHeader;
